import Vue from 'vue'
import VueRouter from 'vue-router'
import productCenter from '../views/productCenter'
import Ancy from "../Ancy.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Ancy',
    component: Ancy,
    meta: {
      title: '百生跃生物官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
      keywords: '生物试剂,PCR试剂盒,DNA marker,培养基,冻存液,蛋白质标准,分析试剂,检测试剂,生化试剂',
      description: '百生跃生物官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,耗材仪器等一站式采购服务平台'
    },
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'homePage',
        component: productCenter,
        meta: {
          title: '百生跃生物官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
          keywords: '生物试剂,PCR试剂盒,DNA marker,培养基,冻存液,蛋白质标准,分析试剂,检测试剂,生化试剂',
          description: '百生跃生物官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,耗材仪器等一站式采购服务平台'
        }
      },
      {
        path: '/productCenter',
        name: 'productCenter',
        component: () => import('../views/homePage'),
        meta: {
          title: '百生跃生物产品中心,百生跃官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
          keywords: '生物试剂查询, DNA marker,培养基,冻存液,蛋白质标准,生物分析检测试剂,生化试剂,百生跃生物',
          description: '百生跃生物产品中心 ,提供PCR试剂盒,分子生物,蛋白质分析,细胞培养试剂,仪器耗材等,上海百生跃生物科技有限公司',
          isLogin: false
        }
      },
      {
        path: "/homepage/detail",
        name: 'detail',
        component: () => import('../views/homePage/detail'),
        meta: {
          title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
          keywords: '',
          description: ''
        }
      },
      {
        path: "/searchData",
        name: 'searchData',
        component: () => import('../views/searchData'),
        meta: {
          title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
          keywords: '',
          description: ''
        }
      },
      {
        path: '/technicalService',
        name: 'technicalService',
        component: () => import('../views/technicalService'),
        meta: {
          title: '百生跃生物技术服务,百生跃专业科研实验服务,提供生物实验服务,生物实验外包服务,分子生物学实验,细胞生物学实验,动物实验,蛋白及免疫学实验等专业实验服务',
          keywords: '生物科研实验服务,生物实验外包服务,百生跃生物,百生跃试剂,实验代做服务,分子生物学实验,细胞生物学实验',
          description: '百生跃生物技术服务,提供专业科研实验服务,生物实验外包服务,分子生物学实验,细胞生物学实验,蛋白及免疫学实验等专业实验服务'
        }
      },
      {
        path: '/tryOut',
        name: 'tryOut',
        component: () => import('../views/tryOut'),
        meta: {
          title: '百生跃生物试用服务,百生跃专业科研实验服务,提供生物实验服务,生物实验外包服务,分子生物学实验,细胞生物学实验,动物实验,蛋白及免疫学实验等专业实验服务',
          keywords: '生物科研实验服务,生物实验外包服务,百生跃生物,百生跃试剂,实验代做服务,分子生物学实验,细胞生物学实验',
          description: '百生跃生物试用服务,提供专业科研实验服务,生物实验外包服务,分子生物学实验,细胞生物学实验,蛋白及免疫学实验等专业实验服务'
        }
      },
      {
        path: '/technicalSupports',
        name: 'technicalSupports',
        component: () => import('../views/technicalSupports'),
        meta: {
          title: '技术支持,百生跃官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材, 生物实验服务等专业一站式采购服务平台',
          keywords: '生物试剂,DNA marker,培养基,冻存液,蛋白质标准,百生跃生物,百生跃试剂,生化试剂',
          description: '技术支持,上海百生跃提供生物试剂,分析试剂,实验试剂,科研试剂,实验仪器耗材等专业一站式采购服务平台'
        },
        redirect: '/technicalSupports/Download',
        children: [
          {
            path: '/technicalSupports/learningCenter',
            name: 'learningCenter',
            component: () => import('../views/technicalSupports/learningCenter'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '生物试剂,DNA marker,培养基,冻存液,蛋白质标准,百生跃生物,百生跃试剂,生化试剂',
              description: '技术支持,上海百生跃提供生物试剂,分析试剂,实验试剂,科研试剂,实验仪器耗材等专业一站式采购服务平台'
            }
          },
          {
            path: '/technicalSupports/Download',
            name: 'Download',
            component: () => import('../views/technicalSupports/Download'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '生物试剂,DNA marker,培养基,冻存液,蛋白质标准,百生跃生物,百生跃试剂,生化试剂',
              description: '技术支持,上海百生跃提供生物试剂,分析试剂,实验试剂,科研试剂,实验仪器耗材等专业一站式采购服务平台'
            }
          },
          {
            path: '/technicalSupports/Inquire',
            name: 'Inquire',
            component: () => import('../views/technicalSupports/Inquire'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '生物试剂,DNA marker,培养基,冻存液,蛋白质标准,百生跃生物,百生跃试剂,生化试剂',
              description: '技术支持,上海百生跃提供生物试剂,分析试剂,实验试剂,科研试剂,实验仪器耗材等专业一站式采购服务平台'
            },
          },
          {
            path: '/technicalSupports/coaInquire',
            name: 'coaInquire',
            component: () => import('../views/technicalSupports/coaInquire'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '生物试剂,DNA marker,培养基,冻存液,蛋白质标准,百生跃生物,百生跃试剂,生化试剂',
              description: '技术支持,上海百生跃提供生物试剂,分析试剂,实验试剂,科研试剂,实验仪器耗材等专业一站式采购服务平台'
            }
          },
          {
            path: '/technicalSupports/experiment',
            name: 'experiment',
            component: () => import('../views/technicalSupports/experiment'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '生物试剂,DNA marker,培养基,冻存液,蛋白质标准,百生跃生物,百生跃试剂,生化试剂',
              description: '技术支持,上海百生跃提供生物试剂,分析试剂,实验试剂,科研试剂,实验仪器耗材等专业一站式采购服务平台'
            }
          }

        ]
      },
      {
        path: '/html',
        name: 'html',
        component: () => import('../views/html'),
        meta: {
          title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
          keywords: '',
          description: ''
        }
      },
      {
        path: '/brandDeatil',
        name: 'brandDeatil',
        component: () => import('../views/brandDeatil'),
        meta: {
          title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
          keywords: '',
          description: ''
        }
      },
      {
        path: '/workIn',
        name: 'workIn',
        component: () => import('../views/workIn'),
        meta: {
          title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
          keywords: '',
          description: ''
        }
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('../views/aboutUs'),
        meta: {
          title: '走进百生跃,百生跃官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
          keywords: '上海百生跃生物试剂,科研服务,实验耗材',
          description: '走进百生跃,生物试剂,科研服务,实验耗材,上海百生跃生物科技有限公司'
        },
        redirect: '/aboutUs/companyProfile',
        children: [
          {
            path: '/aboutUs/companyProfile',
            name: 'companyProfile',
            component: () => import('../views/aboutUs/companyProfile'),
            meta: {
              title: '走进百生跃,百生跃官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
              keywords: '上海百生跃生物试剂,科研服务,实验耗材',
              description: '走进百生跃,生物试剂,科研服务,实验耗材,上海百生跃生物科技有限公司'
            }
          },
          {
            path: '/aboutUs/ProfessionalEngineerIicense',
            name: 'ProfessionalEngineerIicense',
            component: () => import('../views/aboutUs/ProfessionalEngineerIicense'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '上海百生跃生物试剂,科研服务,实验耗材',
              description: '走进百生跃,生物试剂,科研服务,实验耗材,上海百生跃生物科技有限公司'
            }
          },
          {
            path: '/aboutUs/concatUs',
            name: 'concatUs',
            component: () => import('../views/aboutUs/concatUs'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '上海百生跃生物试剂,科研服务,实验耗材',
              description: '走进百生跃,生物试剂,科研服务,实验耗材,上海百生跃生物科技有限公司'
            }
          },
          {
            path: '/aboutUs/talentedPeople',
            name: 'talentedPeople',
            component: () => import('../views/aboutUs/talentedPeople'),
            meta: {
              title: '加入我们,百生跃官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
              keywords: '生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂,上海百生跃',
              description: '加入我们,上海百生跃生物科技有限公司'
            }
          },
          {
            path: '/aboutUs/agentInvestment',
            name: 'agentInvestment',
            component: () => import('../views/aboutUs/agentInvestment'),
            meta: {
              title: '生物试剂查询,生物试剂购买网站,百生跃,百生跃生物,百生跃试剂,百生跃官网,生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂',
              keywords: '生物试剂,分析试剂,检测试剂,科研试剂,实验室试剂,生化试剂,上海百生跃',
              description: '加入我们,上海百生跃生物科技有限公司'
            }
          }
        ]
      },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter'),
        meta: {
          title: '个人中心'
        },
        redirect: "/personalCenter/personalinfo",
        children: [
          {
            path: '/personalCenter/personalinfo',
            name: 'personalinfo',
            component: () => import('../views/personalCenter/personalinfo'),
            meta: {
              title: '个人信息'
            }
          },
          {
            path: '/personalCenter/orderCenter',
            name: 'orderCenter',
            component: () => import('../views/personalCenter/orderCenter'),
            meta: {
              title: '订单中心'
            },
            children: [
              {
                path: '/personalCenter/orderCenter/detail',
                name: 'orderDetail',
                component: () => import('../views/personalCenter/orderCenter/Detail'),
                meta: {
                  title: '订单详情'
                },
              }
            ]
          },
          {
            path: '/personalCenter/tryOrderCenter',
            name: 'tryOrderCenter',
            component: () => import('../views/personalCenter/tryOrderCenter'),
            meta: {
              title: '试用商品订单'
            },
            children: [
              {
                path: '/personalCenter/tryOrderCenter/detail',
                name: 'tryOrderDetail',
                component: () => import('../views/personalCenter/tryOrderCenter/Detail'),
                meta: {
                  title: '试用订单详情'
                },
              }
            ]
          },
          {
            path: '/personalCenter/afterSaleList',
            name: 'tryOrderCenter',
            component: () => import('../views/personalCenter/afterSaleList'),
            meta: {
              title: '售后信息'
            },
            // children: [
            //   {
            //     path: '/personalCenter/tryOrderCenter/detail',
            //     name: 'tryOrderDetail',
            //     component: () => import('../views/personalCenter/tryOrderCenter/Detail'),
            //     meta: {
            //       title: '试用订单详情'
            //     },
            //   }
            // ]
          },
          {
            path: '/personalCenter/cancelOrderPage',
            name: 'tryOrderCenter',
            component: () => import('../views/personalCenter/cancelOrderPage'),
            meta: {
              title: '取消订单'
            },
            // children: [
            //   {
            //     path: '/personalCenter/tryOrderCenter/detail',
            //     name: 'tryOrderDetail',
            //     component: () => import('../views/personalCenter/tryOrderCenter/Detail'),
            //     meta: {
            //       title: '试用订单详情'
            //     },
            //   }
            // ]
          },
          {
            path: '/personalCenter/addressManage',
            name: 'addressManage',
            component: () => import('../views/personalCenter/addressManage'),
            meta: {
              title: '地址管理'
            }
          },
          {
            path: '/personalCenter/InvoiceControl',
            name: 'InvoiceControl',
            component: () => import('../views/personalCenter/InvoiceControl'),
            meta: {
              title: '发票管理'
            }
          },
          {
            path: '/personalCenter/changePassword',
            name: 'changePassword',
            component: () => import('../views/personalCenter/changePassword'),
            meta: {
              title: '修改密码'
            }
          },
          {
            path: '/personalCenter/balance',
            name: 'balance',
            component: () => import('../views/personalCenter/balance'),
            meta: {
              title: '余额日志'
            }
          },
          {
            path: '/personalCenter/credit',
            name: 'credit',
            component: () => import('../views/personalCenter/credit'),
            meta: {
              title: '信用日志'
            }
          }
        ]
      },
      {
        path: '/shopingCart',
        name: 'shopingCart',
        component: () => import('../views/shopingCart'),
        meta: {
          title: '购物车'
        },
        redirect: "/shopingCart/car",
        children: [
          {
            path: '/shopingCart/car',
            name: 'car',
            component: () => import('../views/shopingCart/car'),
            meta: {
              title: '我的购物车'
            },
          },
          {
            path: '/shopingCart/myorder',
            name: 'myorder',
            component: () => import('../views/shopingCart/Myorder'),
            meta: {
              title: '我的订单'
            }
          },
          {
            path: '/shopingCart/payload',
            name: 'payload',
            component: () => import('../views/shopingCart/payload'),
            meta: {
              title: '付款'
            },
          }
        ]
      },
      {
        path: '/calculator',
        name: 'calculator',
        component: () => import('../views/calculator/index.vue'),
        meta: {
          title: '百生跃生物官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,实验仪器耗材,生物实验服务等专业一站式采购服务平台',
          keywords: '生物试剂,PCR试剂盒,DNA marker,培养基,冻存液,蛋白质标准,分析试剂,检测试剂,生化试剂',
          description: '百生跃生物官方网上商城,提供生物试剂,分析试剂,检测试剂,实验试剂,科研试剂,耗材仪器等一站式采购服务平台'
        }
      }
    ]
  },
  {
    path: '/orderSubmit',
    name: 'orderSubmit',
    component: () => import('../views/orderSubmit'),
    meta: {
      title: '已生成订单'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login'),
    meta: {
      title: '登录',
      isLogin: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register'),
    meta: {
      title: '注册',
      isLogin: false
    }
  },
  {
    path: '/activationCode',
    name: 'activationCode',
    component: () => import('../views/activationCode'),
    meta: {
      title: '激活'
    }
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('../views/forget/forgetPassword'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/findPassword',
    name: 'findPassword',
    component: () => import('../views/findPassword'),
    meta: {
      title: '找回密码'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.afterEach((to, from, next) => {
  document.title = to.meta.title
  document.querySelector('meta[name="keywords"]').content = to.meta.keywords
  document.querySelector('meta[name="description"]').content = to.meta.description
})

router.beforeEach((to, from, next) => {
  if (to.matched.length ===0) {
    from.name ? next({ name:from.name }) : next('/');
  } else {
    next();
  }
});
export default router
